import { render, staticRenderFns } from "./xskUploadQn.vue?vue&type=template&id=32775b93&"
import script from "./xskUploadQn.vue?vue&type=script&lang=js&"
export * from "./xskUploadQn.vue?vue&type=script&lang=js&"
import style0 from "./xskUploadQn.vue?vue&type=style&index=0&lang=css&"
import style1 from "./xskUploadQn.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports